import Measurer from './Measurer';
import { update } from 'Emitter';
import { APPLICATION, MEASUREMENT } from 'StateEvents';

export default class ApplicationMeasurer extends Measurer {
  onUpdate(nextState, prevState, changes) {
    super.onUpdate(nextState, prevState, changes);

    if(changes.errors && nextState.errors.length) {
      this
        .queueRequests(
          nextState.configuration.Events.error, 
          MEASUREMENT.ERROR, { 
            macros: {
              ERROR_CODE: nextState.errors.join('')
            }
          }
        )
        .then(() => {
          update(APPLICATION.ERROR_LOGGED, 'onUpdate');
        });
    }
  }
}


// WEBPACK FOOTER //
// ./src/Services/Measurement/ApplicationMeasurer.js